import "./styles/site.css";
import "./styles/chinese.css";
import "./styles/language.css";
import { initializeLocale } from "./content/index.js";

// 先应用文案，再让场景记录文本、字素与布局尺寸。
initializeLocale();
await import("./runtime/application.js");
